import { UPDATE_CHECKOUT_SHOPIFY } from './types'

export const UpdateCheckoutShopify = payload => {
  return {
    type: UPDATE_CHECKOUT_SHOPIFY,
    payload,
  }
}
